import { useSelector } from 'react-redux';
import { SetupData } from '../../redux/localReports/localReports.proptype';
import { selectSetupData } from '../../selectors';

export const useSetupData = (): SetupData => {
  const setupData = useSelector(selectSetupData);

  return setupData;
};
